import setAuthToken from "../utils/setAuthToken";
import {SET_AUTH_USER, UNSET_USER} from "../stores/auth";
import user from "../data/user.json";
import cogoToast from "cogo-toast";
import axios from "axios";
import {LOGIN_URL} from "api";
import jwt_decode from "jwt-decode";
import {getAdminById} from "./admin";

const option = {
    position: "top-right",
    hideAfter: 2,
};

//Login - Auth Token
export const loginUser = (userData) => {
    return async function (dispatch) {
        await axios
            .post(LOGIN_URL, userData)
            .then((response) => {
                if (response.status === 200) {
                    return getUser(response.data.token)
                }
                throw new Error('Login failed');
            })
            .then((res) => {
                dispatch(SET_AUTH_USER({user: res.payload, isAuthenticated: true}));
            }).catch((error) => {
                console.log("error", error);
                cogoToast.error("Something went wrong", option);
                return false;
            })
    };
};

export const logoutUser = () => {
    return function (dispatch) {
        //Remove toke from localStorage
        localStorage.clear();

        //Remove auth header for future requests
        setAuthToken(false);

        //Set current user to {} which will set isAuthenticated to false
        dispatch(UNSET_USER());
    };
};

const getUser = (token) => {
    const decoded = jwt_decode(token);
    const id = decoded['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid']
    return getAdminById(id)
}